import { environment } from '$environments/environment';
import { ConfirmService } from '$services/confirm.service';
import { ContactMessageForm } from '$types';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ContactService {
    private postsUrl = environment.apiUrl + '/rest/contacts'

    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly confirmService: ConfirmService,
        private readonly http: HttpClient,
        private readonly snackBar: MatSnackBar) { }

    buildForm(): FormGroup {
        return this.formBuilder.group({
            gender: [null, [Validators.required]],
            lastName: this.requiredAndLength(1),
            email: [
                null,
                [
                    Validators.required,
                    Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
                ],
            ],
            firstName: this.requiredAndLength(1),
            landlinePhoneNumber: [null],
            mobilePhoneNumber: [null],
            questionType: [null, [Validators.required]],
            message: [null, [Validators.required]],
        })
    }

    askAndSend(data: ContactMessageForm): void {

        this.confirmSend()
            .subscribe((status) => {
                if (!status) {
                    return
                }
                this.send(data).subscribe(
                    {
                        complete: () => {
                            console.log('message envoyé')
                            this.snackBar.open("✅ : le message a bien été envoyé", 'Ok', {
                                duration: 3000,
                                verticalPosition: 'top',
                                panelClass: ['bg-green'],
                            });

                        },
                        error: (err) => {
                            console.error('erreur')
                            this.snackBar.open('⚠ : une erreur est survenue', 'x', {
                                duration: 5000,
                                verticalPosition: 'top',
                                panelClass: ['bg-red'],
                            });
                        },
                    }
                )
            })
    }
    confirmSend(): Observable<any> {
        return this.confirmService
            .ConfirmDialog(`Confirmer l'envoi de votre message ?`, `Nous vous répondrons dans les plus brefs délais ?`)
            ;
    }
    send(data: ContactMessageForm): Observable<any> {
        return this.http.post<any>(`${this.postsUrl}`, data)
    }
    private requiredAndLength(length: number) {
        return [null, [Validators.required, Validators.minLength(length)]]
    }
}
